import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="max-w-[820px] mx-auto px-4 md:px-8 pt-10 md:pt-16 pb-16">
      <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
        <Link to="/" className="text-text-secondary hover:text-accent transition-colors">Home</Link>
        <span>/</span>
        <span>About</span>
      </div>

      <h1 className="font-display text-2xl md:text-[2.5rem] font-bold tracking-tight mb-6">About MarineLink</h1>

      <div className="article-body">
        <p>
          MarineLink is New Zealand's marine industry directory - and has been for more than 25 years.
          Long before Google Maps knew where your local boatyard was, MarineLink was connecting Kiwi
          boaties, sailors and fishers with the businesses that keep them on the water.
        </p>

        <p>
          The idea has never changed: one place where you can find a chandler, a charter, a boat builder,
          a marina berth, a sail maker or a diesel engineer - anywhere in New Zealand - and know the
          listing is real, current and worth your time.
        </p>

        <h2>Who's behind it</h2>

        <p>
          MarineLink is managed by <strong>Phil Wesley-Brown</strong>, an Auckland-based marine professional
          who has built many marine-related websites over the years. Phil's background is the marine
          industry itself, not just the web - which is why MarineLink has always been built by someone
          who actually knows the difference between a saildrive and a sailmaker.
        </p>

        <h2>What we do today</h2>

        <p>
          The directory covers the whole country - from Whangārei's refit yards to Bluff's fishing fleets -
          across charters, chandlers, boat builders, electronics, marinas, engineering, transport and more.
          Every listing is reviewed, and we run regular quality checks on images, descriptions and contact
          details so the directory stays trustworthy.
        </p>

        <p>
          We also publish <Link to="/news" className="text-accent hover:underline">Marine News</Link> -
          daily coverage of the New Zealand marine industry, from boat building and marine tech to racing
          results and coastal conservation.
        </p>

        <h2>For marine businesses</h2>

        <p>
          A listing on MarineLink puts your business in front of the people already looking for what you do.
          Basic listings are straightforward to set up, and premium options put you front and centre in your
          category.
        </p>
      </div>

      <div className="flex flex-wrap gap-3 mt-10">
        <Link to="/list" className="btn btn-primary">List your business</Link>
        <Link to="/browse" className="btn btn-ghost">Browse the directory</Link>
      </div>
    </div>
  );
}
